export { default as Component } from "./Audio.svelte";
export const modes = ["static", "dynamic"];
